/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as overlayActions from './overlayActions.js';
import * as appActions from '../../appActions';
import './overlayStyle.less';
import './scrollLock.less';

class OverlayFull extends Component {
  constructor() {
    super();
    this.state = { top: '' };
  }

  stopPropagation(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  render() {
    const { type, show, content, combineAndSaveOffers } = this.props;
    const className =
      type === 'double' && combineAndSaveOffers.length > 0
        ? type
        : type !== 'double'
        ? type
        : '';
    return (
      <div className={show ? 'overlayWrapper w-active' : 'overlayWrapper'}>
        <div
          id="pdp-cart-overlay"
          className={show ? 'h-overlay active' : 'h-overlay'}
          onClick={() => this.props.CLOSE_OVERLAY()}
        />
        <div
          className={`${
            !this.props.app.isCustomizationOpen && className
          } d-overlay !z-[9000]`}
          style={{
            top: this.state.top,
            height:
              this.state.top === '0px'
                ? null
                : `calc(100vh - ${this.state.top})`,
            display: show ? null : 'none'
          }}
        >
          {show && (
            <div className="overlayFull" id="overlay">
              <div
                className="overlayContentholder"
                onClick={() => this.stopPropagation}
              >
                {content}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ overlayFull, offers, app }) => {
  return {
    app,
    type: overlayFull.type,
    show: overlayFull.show,
    content: overlayFull.content,
    combineAndSaveOffers: offers.combineAndSaveOffers
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      ...appActions,
      ...overlayActions
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(OverlayFull);
